import styled from "@emotion/styled";

export const IconContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  inline-size: 52px;
  block-size: 35px;
  margin-inline-end: 12px;
  box-sizing: border-box;

  border: 1px solid #d7d7d7;
  border-radius: 2px;

  background: #000000;

  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
`;
